<template>
    <div class="card-container">
        <p style="margin-bottom: 30px;display: inline-block;">名称： {{platoonInfo.platoonName}}</p>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column type="index" min-width="80" label="序号"></el-table-column>
            <el-table-column prop="level" min-width="80" label="排位等级"
                             :formatter="formatterTableLevel"></el-table-column>
            <el-table-column prop="money" label="排位金额（元）" min-width="130" :formatter="formatterTableNumber"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="排位类型" min-width="160" :formatter="formatterTableType"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="peopleNumber" label="排位人数（人）" min-width="130" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="profit" label="排位奖励金额(元)" min-width="130" :formatter="formatterTableNumber"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" min-width="130" :formatter="formatterEnable"
                             show-overflow-tooltip></el-table-column>
            <!--<el-table-column prop="createUserName" label="排位通道" min-width="100" show-overflow-tooltip>-->
                <!--<template slot-scope="scope">-->
                    <!--<el-button type="text" @click="detailForLineName(scope.row.id)">查看</el-button>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="updateTime" label="操作时间" min-width="160" :formatter="formatterTableDate"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="modifier" label="操作人" min-width="160" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="180"
                             v-if="(hasPerm('/tatPublicPlatoon/edit') || hasPerm('/tatPublicPlatoon/udpStatus') || hasPerm('/tatPublicPlatoon/delete'))">
                <template slot-scope="scope">
                    <el-button type="text" @click="addInfo(scope.row)" v-if="hasPerm('/tatPublicPlatoon/edit')">详情</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel" :show="false"
                     :submitData="dialogData" :rules="dialogRules" :dialogService="dialogService" class="platoonDialog"
                     @success="dialogSuccess" @close="dialogClose">

                <el-form-item label="排位金额" prop="money">
                    <el-input-number v-model="dialogModel.money" :controls="false" controls-position="right"
                                     :precision="2" :step="0.1" :min="0" :max="9999999999999" :disabled="true"
                                     style="width: 91%"></el-input-number>
                    <span>元</span>
                </el-form-item>
                <el-form-item label="快捷收款" prop="qpayEnable" class="overSize">
                    <el-switch
                        v-model="dialogModel.qpayEnable" active-value="1" inactive-value="0" :disabled="true">
                    </el-switch>
                </el-form-item>
                <el-form-item label="智能还款" prop="repayEnable" class="overSize">
                    <el-switch
                        v-model="dialogModel.repayEnable" active-value="1" inactive-value="0" :disabled="true">
                    </el-switch>
                </el-form-item>
                <el-form-item label="排位人数" prop="peopleNumber">
                    <el-input-number v-model="dialogModel.peopleNumber" :controls="false" controls-position="right" :disabled="true"
                                     :precision="0" :step="1" :min="0" style="width: 91%"></el-input-number>
                    <span>人</span>
                </el-form-item>
                <el-form-item label="奖励金额" prop="profit">
                    <el-input-number v-model="dialogModel.profit" :controls="false" controls-position="right" :disabled="true"
                                     :precision="2" :step="0.1" :min="0" :max="9999999999999"
                                     style="width: 91%"></el-input-number>
                    <span>元</span>
                </el-form-item>
                <!--<el-form-item label="统计路线" prop="chnCodeArr">-->
                    <!--<el-select v-model="dialogModel.chnCodeArr" filterable multiple collapse-tags clearable-->
                               <!--placeholder="请选择" @change="handleChange">-->
                        <!--<el-option-->
                            <!--v-for="item in topShortNames"-->
                            <!--:key="item.id"-->
                            <!--:label="item.shortName"-->
                            <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->

                    <el-form-item>
                        <div class="flex-col vertical-start up-level-box">
                            <div class="flex-row vertical-center">
                                <el-button type="primary" size="small" @click="addLevelItem" :disabled="true" style="margin-bottom: 20px">
                                    添加卓越领导奖励
                                </el-button>
                                <el-form-item label="层数" style="margin-bottom: 20px">
                                    <el-input-number placeholder="请输入层数" :controls="false"
                                                     v-model="dialogModel.secondElementInfoNumber" controls-position="right"
                                                     @change="handleChange" :disabled="true"
                                                     :min="0" :max="999999" :precision="0"
                                                     :step="1"></el-input-number>
                                </el-form-item>
                            </div>

                            <div class="levelList">
                                <div class="flex-row vertical-center flow-justify up-people-list"
                                     :class="{'pad-right':dialogModel.secondElementInfo.length == 1}"
                                     v-for="(item, index) in dialogModel.secondElementInfo" :key="index"
                                     style="margin-bottom: 20px">
                                    <el-form-item label="卓越等级" :prop="'secondElementInfo.' + index + '.seatId'"
                                                  :rules="seatLevelRules"
                                                  style="margin-right: 20px">
                                        <el-select v-model="item.seatId" placeholder="请选择" :disabled="true">
                                            <el-option
                                                v-for="item in seatList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item :prop="'secondElementInfo.' + index + '.levelMoney'"
                                                  :rules="secondElementInfoLevelMoney">
                                        <el-input-number placeholder="请输入分润金额" :controls="false"
                                                         v-model="item.levelMoney" controls-position="right"
                                                         @change="handleChange" :disabled="true"
                                                         :min="0" :max="999999" :precision="2"
                                                         :step="0.1"></el-input-number>
                                        <p class="unit">元</p>
                                    </el-form-item>
                                    <el-button @click.prevent="removeLevelItem(item)" :disabled="true">
                                        删除
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="flex-col vertical-start up-level-box">
                            <el-button type="primary" size="small" @click="addParentInfo" :disabled="true" style="margin-bottom: 20px">
                                添加团队交易补贴
                            </el-button>
                            <div class="levelList flex-col vertical-start flow-justify">
                                <div class="flex-row vertical-center up-people-list"
                                     :class="{'pad-right':dialogModel.parentInfo.length == 1}"
                                     v-for="(item, index) in dialogModel.parentInfo" :key="index"
                                     style="margin-bottom: 20px">
                                    <p style="margin-right: 20px">层级{{index + 1}}</p>
                                    <el-form-item :prop="'parentInfo.' + index + '.levelMoney'"
                                                  :rules="parentInfoLevelMoney">
                                        <el-input-number placeholder="请输入分润金额" :controls="false"
                                                         v-model="item.levelMoney" controls-position="right"
                                                         @change="handleChange" :disabled="true"
                                                         :min="0" :max="999999" :precision="2"
                                                         :step="0.1"></el-input-number>
                                        <p class="unit">元</p>
                                    </el-form-item>
                                    <el-button @click.prevent="removeParentInfo(item)" :disabled="true"
                                               v-if="index == dialogModel.parentInfo.length -1">
                                        删除
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTable from 'components/common/CommonTable'
    import FormDialog from '../../dialog/FormDialog'

    import MemberLevelService from 'service/MemberLevelService'
    import MarketService from 'service/MarketService'
    import PlatoonLevel from 'service/constant/PlatoonLevel'
    import Regs from "common/conf/Regs";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "setpublicplatoon",
        components: {
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                dialogModel: {
                    money: '',
                    peopleNumber: '',
                    profit: '',
                    qpayEnable: '',
                    repayEnable: '',
                    secondElementInfoNumber: '',
                    // chnCodeArr: [],
                    secondElementInfo: [],
                    parentInfo: []
                },
                PlatoonLevel: PlatoonLevel,
                formDialogTitle: '',
                submitService: MarketService.tatPublicPlatoonList,
                tableData: [],
                seatList: [],
                topShortNames: [],
                chnArr: '',
                changeChnArr: [],
                isPage: false,
                dialogId: '',
                page: {},
                dialogRules: {
                    // chnCodeArr: [{
                    //     required: true,
                    //     message: '请选择统计路线'
                    // }],
                    peopleNumber: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                return callback(new Error('排位人数不能为空'));
                            }
                            return callback();
                        },
                    }],
                    profit: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                return callback(new Error('奖励金额不能为空'));
                            }
                            return callback();
                        },
                    }],
                    qpayEnable: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (this.dialogModel.repayEnable == 1 || value == 1) {
                                return callback()
                            }
                            return callback(new Error('请选择【快捷收款】或【智能还款】'))
                        },
                    }],
                    repayEnable: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (this.dialogModel.qpayEnable == 1 || value == 1) {
                                return callback()
                            }
                            return callback(new Error('请选择【快捷收款】或【智能还款】'))
                        },
                    }],
                },
                secondElementInfoLevelMoney:{
                    required: false,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请输入分润金额'))
                        } else {
                            callback()
                        }
                    },
                },
                parentInfoLevelMoney:{
                    required: false,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请输入分润金额'))
                        } else {
                            callback()
                        }
                    },
                },
                seatLevelRules:{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                          return callback(new Error('请选择卓越等级'))
                        }

                        const arr = this.dialogModel.secondElementInfo;
                        let index = 0;
                        arr.forEach(item => {
                            arr.forEach(compare => {
                                if (item.seatId == compare.seatId) {
                                    index ++;
                                }
                            })
                        });

                        if (index > arr.length) {
                            return callback(new Error('卓越等级不能重复'))
                        }
                        return callback();
                    },
                },
                platoonInfo:{},
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            submitData() {
                const params = {
                    pId: this.platoonInfo.id,
                    tatSimpleId: this.platoonInfo.tatSimpleId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return params;
            },
            dialogService() {
                return this.dialogId ? MarketService.tatPublicPlatoonEdit : MarketService.tatPublicPlatoonAdd;
            },
            dialogData() {
                let secondElementInfo = [];
                let parentInfo = [];
                this.dialogModel.secondElementInfo.forEach(item => {
                    secondElementInfo.push([item.seatId, item.levelMoney])
                });
                this.dialogModel.parentInfo.forEach((item, index) => {
                    parentInfo.push(item.levelMoney)
                });
                // console.log(this.changeChnArr, this.dialogModel.chnCodeArr)

                const params = {
                    secondElementInfo: secondElementInfo.join(';'),
                    parentInfo: parentInfo.join(','),
                    pId: this.platoonInfo.id,
                    money: this.dialogModel.money * 100,
                    peopleNumber: this.dialogModel.peopleNumber,
                    profit: this.dialogModel.profit * 100,
                    qpayEnable: this.dialogModel.qpayEnable,
                    repayEnable: this.dialogModel.repayEnable,
                    secondElementInfoNumber: this.dialogModel.secondElementInfoNumber,
                    // chnCodeStrs: this.dialogModel.chnCodeArr.toString(),
                    modifier: this.userId
                };
                if (this.dialogId) {
                    params.id = this.dialogId;
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        created(){
            this.platoonInfo = JSON.parse(this.$route.params.item);
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            // this.getShortNames('', (res) => {
            //     this.topShortNames = res;
            // });
            this.getList();
            this.getSeatList();
        },
        methods: {
            getSeatList() {
                this.doLoad(MemberLevelService.listNoPage, '', res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.seatList = result;
                    });
                }, '信息获取失败')
            },
            removeLevelItem(item) {
                this.showConfirm('确定要删除此层级吗？').then(() => {
                    let index = this.dialogModel.secondElementInfo.indexOf(item);
                    if (index !== -1) {
                        this.dialogModel.secondElementInfo.splice(index, 1)
                    }
                }).catch(() => {
                });
            },
            addLevelItem() {
                if (this.dialogModel.secondElementInfo.length > this.seatList.length) {
                    this.$alert('已加载全部卓越等级', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                    return;
                }
                this.dialogModel.secondElementInfo.push({
                    seatId: '',
                    levelMoney: 0
                });
            },
            removeParentInfo(item) {
                this.showConfirm('确定要删除此层级吗？').then(() => {
                    let index = this.dialogModel.parentInfo.indexOf(item);
                    if (index !== -1) {
                        this.dialogModel.parentInfo.splice(index, 1)
                    }
                }).catch(() => {
                });
            },
            addParentInfo() {
                this.dialogModel.parentInfo.push({
                    levelMoney: 0
                });
            },
            handleChange(val) {
                this.$forceUpdate();
                this.$nextTick(() => {
                    this.changeChnArr = val;
                });
            },
            formatterTableLevel(row, column, cellValue, index) {
                let value = '';
                this.PlatoonLevel.forEach(item => {
                    if (item.value == cellValue) {
                        value = item.label
                    }
                });
                return value ? value : '--';
            },
            formatterTableType(row, column, cellValue, index) {
                return row.qpayEnable == 1 ? (row.repayEnable == 1 ? '快捷收款/智能还款' : '快捷收款') : row.repayEnable == 1 ? '智能还款' : '';
            },
            formatterTableDate(row, column, cellValue, index) {
                return row.updateTime ? row.updateTime : row.createTime;
            },
            addInfo(item) {
                this.dialogId = '';
                if (item) {
                    this.dialogId = item.id;
                    this.getDetail(item)
                }
                this.formDialogTitle = this.dialogId ? '添加' : '修改';
                this.$refs.formDialog.open();
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                });
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    }, '信息获取失败'
                )
            },
            detailForLineName(id) {
                this.doLoad(MarketService.detailForLineName, {
                    pId: this.platoonInfo.id,
                        id: id
                    }, res => {
                        this.chnArr = res.contents;
                        this.$nextTick(() => {
                            this.formDialogTitle = '排位通道';
                            this.$refs.formDialog.open();
                        })
                    }, '信息获取失败'
                )
            },
            getDetail(item) {
                this.dialogModel = JSON.parse(JSON.stringify(item));
                this.dialogModel.money = this.dialogModel.money * 100 / 10000;
                this.dialogModel.profit = this.dialogModel.profit * 100 / 10000;
                // this.dialogModel.chnCodeArr = this.dialogModel.chnCodeStrs.split(',');
                const parentInfo = this.dialogModel.parentInfo ? this.dialogModel.parentInfo.split(',') : [];
                const secondElementInfo = this.dialogModel.secondElementInfo ? this.dialogModel.secondElementInfo.split(';') : [];
                this.dialogModel.parentInfo = parentInfo.map(item => ({
                    levelMoney:item
                }));
                this.dialogModel.secondElementInfo = secondElementInfo.map(item => ({
                    seatId: item.split(',')[0] ? Number(item.split(',')[0]) : '',
                    levelMoney: item.split(',')[1]
                }));

            },
            dialogSuccess(data) {
                this.doCheck(data, res => {
                    const result = res.contents;
                    this.showSuccess(result.optMsg);
                    this.getList();
                    this.$refs.formDialog.closeDialog();
                });
            },
            dialogClose() {
                this.dialogModel = {
                    money: '',
                    peopleNumber: '',
                    profit: '',
                    qpayEnable: '',
                    secondElementInfoNumber: '',
                    repayEnable: '',
                    // chnCodeArr: [],
                    parentInfo: [],
                    secondElementInfo: [],
                };
                this.changeChnArr = []
            },
            doDisabled(id, type) {
                const disabledParams = {
                    id: id,
                    pId: this.platoonInfo.id,
                    userId: this.userId,
                    status: type == 1 ? 0 : 1,
                };

                this.doLoad(MarketService.tatPublicPlatoonUdp, disabledParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            Disabled(id, type) {
                this.showConfirm(`确定${type == 1 ? '禁用' : '启用'}此公排？`).then(() => {
                    this.doDisabled(id, type)
                }).catch(() => {
                });
            },
            doDelete(id) {
                this.doLoad(MarketService.tatPublicPlatoonDel, {
                    pId: this.platoonInfo.id,
                    id: id
                }, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            Delete(id) {
                this.showConfirm(`确定删除此公排？`).then(() => {
                    this.doDelete(id)
                }).catch(() => {
                });
            },
        }
    }
</script>

<style scoped>
    .levelList {
        display: flex;
        flex-wrap: wrap;
    }

    .unit {
        margin-left: 10px;
        color: #aaaaaa;
        word-break: keep-all;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/SetPublicPlatoon.vue